import React from 'react';
import { Bug, Sparkles, ListTodo, User, Calendar } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';

const TableroView = ({ solicitudes, loading, onViewDetail, getTipoIcon, getTipoLabel, getPrioridadColor }) => {
  const columnas = [
    { id: 'pendiente', titulo: 'Pendiente', color: 'border-yellow-500' },
    { id: 'en_progreso', titulo: 'En Progreso', color: 'border-blue-500' },
    { id: 'completado', titulo: 'Completado', color: 'border-green-500' },
    { id: 'cerrado', titulo: 'Cerrado', color: 'border-gray-500' },
  ];

  const getSolicitudesPorEstado = (estado) => {
    return solicitudes.filter(s => s.estado === estado);
  };

  if (loading) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Cargando tablero...</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {columnas.map((columna) => {
        const tareasColumna = getSolicitudesPorEstado(columna.id);
        
        return (
          <div key={columna.id} className="flex flex-col">
            <Card className={`border-t-4 ${columna.color} flex-1`}>
              <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                  <CardTitle className="text-lg">{columna.titulo}</CardTitle>
                  <Badge variant="secondary">{tareasColumna.length}</Badge>
                </div>
              </CardHeader>
              <CardContent>
                <ScrollArea className="h-[calc(100vh-300px)]">
                  <div className="space-y-3 pr-4">
                    {tareasColumna.length === 0 ? (
                      <p className="text-sm text-muted-foreground text-center py-8">
                        No hay tareas
                      </p>
                    ) : (
                      tareasColumna.map((solicitud) => (
                        <Card
                          key={solicitud._id}
                          className="cursor-pointer hover:shadow-lg transition-all hover:scale-[1.02]"
                          onClick={() => onViewDetail(solicitud)}
                        >
                          <CardContent className="p-4">
                            <div className="space-y-3">
                              {solicitud.consecutivo && (
                                <Badge variant="outline" className="font-mono text-xs w-fit">
                                  {solicitud.consecutivo}
                                </Badge>
                              )}
                              <div className="flex items-start gap-2">
                                {getTipoIcon(solicitud.tipo)}
                                <h4 className="font-semibold text-sm line-clamp-2 flex-1">
                                  {solicitud.titulo}
                                </h4>
                              </div>
                              
                              <p className="text-xs text-muted-foreground line-clamp-2">
                                {solicitud.descripcion}
                              </p>
                              
                              <div className="flex flex-wrap gap-1">
                                <Badge 
                                  variant={getPrioridadColor(solicitud.prioridad)}
                                  className="text-xs"
                                >
                                  {solicitud.prioridad}
                                </Badge>
                                <Badge variant="outline" className="text-xs">
                                  {getTipoLabel(solicitud.tipo)}
                                </Badge>
                                {solicitud.modulo && (
                                  <Badge variant="secondary" className="text-xs">
                                    {solicitud.modulo}
                                  </Badge>
                                )}
                              </div>
                              
                              {solicitud.asignadoA ? (
                                <div className="flex items-center gap-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-1 rounded-full text-xs font-medium">
                                  <User className="h-3 w-3" />
                                  <span className="truncate">{solicitud.asignadoA.nombre}</span>
                                </div>
                              ) : (
                                <div className="flex items-center gap-1 bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 px-2 py-1 rounded-full text-xs">
                                  Sin asignar
                                </div>
                              )}
                              
                              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                                <Calendar className="h-3 w-3" />
                                <span>{new Date(solicitud.fechaCreacion).toLocaleDateString()}</span>
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      ))
                    )}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>
          </div>
        );
      })}
    </div>
  );
};

export default TableroView;
